import { FaUser, FaMapMarkerAlt, FaClock, FaTruck, FaWhatsapp, FaShieldAlt, FaLeaf, FaTrophy, FaHeart } from "react-icons/fa";
import { FiHeart } from "react-icons/fi";
import { WishlistContext } from "../../Context/WishlistContext";
import { MdLocalShipping, MdVerified } from "react-icons/md";
import React, { useContext, useState, useEffect } from "react";
import "./ProductDisplay.css";
import logo from "../Assets/logo-04.png";
import quality_icon from "../Assets/quality.png";
import money_icon from "../Assets/save-money.png";
import trust_icon from "../Assets/trust.png";
import { ShopContext } from "../../Context/ShopContext";
import { backend_url, currency } from "../../App";
import About from "../About/About";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import OrderPopup from "../OrderPopUp/OrderPopUp";
import { useNavigate } from "react-router-dom";
import EstimatorModal from "./EstimatorModal";
import EstimatorImage1 from "../Assets/est-1.jpeg";
import EstimatorImage2 from "../Assets/est-2.jpeg";

const Products = ({ product }) => {
  const navigate = useNavigate();
  const isAuthorize = !!localStorage.getItem("auth-token");

  const [count, setCount] = useState(1);
  const [activeTab, setActiveTab] = useState("Description");
  const { addToCart, cartItems, deleteFromCart } = useContext(ShopContext);
  const { toggleWishlist, isWishlisted } = useContext(WishlistContext);
  const wishlisted = isWishlisted(product?.id);
  const [selectedImage, setSelectedImage] = useState(product?.images?.[0]);
  const [zoomStyle, setZoomStyle] = useState({});
  const [selectedSize, setSelectedSize] = useState("");
  const [showPopup, setShowPopup] = useState(false);
  const [userDetails, setUserDetails] = useState({});
  const [openModal, setOpenModal] = useState(false);
  const [showRequestForm, setShowRequestForm] = useState(false);
  const [requestQty, setRequestQty] = useState(1);
  const [requestNote, setRequestNote] = useState("");

  useEffect(() => {
    const fetchUserDetails = async () => {
      try {
        const token = localStorage.getItem("auth-token");
        if (!token) return;
        const response = await fetch(`${backend_url}/getuserdetails`, {
          method: "GET",
          headers: { "auth-token": token },
        });
        const data = await response.json();
        if (data.success) setUserDetails(data.user);
      } catch (error) {
        console.error("Error fetching user details:", error);
      }
    };
    fetchUserDetails();
  }, []);

  const handlePopupNow = () => {
    if (!isAuthorize) {
      toast.info("Please Login/Register to continue with your order");
      setTimeout(() => navigate("/login"), 1500);
      return;
    }
    setShowPopup(true);
  };

  const handleInputChange = (e) => {
    const value = parseFloat(e.target.value);
    const maxQty = product?.quantity || Infinity;
    if (!isNaN(value) && value >= 0.5) setCount(Math.min(value, maxQty));
  };

  const closePopup = () => setShowPopup(false);

  const handleMouseMove = (e) => {
    const { left, top, width, height } = e.target.getBoundingClientRect();
    const x = ((e.clientX - left) / width) * 100;
    const y = ((e.clientY - top) / height) * 100;
    setZoomStyle({ transformOrigin: `${x}% ${y}%`, transform: "scale(2)", transition: "transform 0.1s ease" });
  };

  const handleMouseLeave = () => setZoomStyle({ transform: "scale(1)" });

  const discountPercentage = product.new_price;
  const newPrice = product.old_price
    ? (product.old_price * (100 - discountPercentage)) / 100
    : product.new_price;

  const step = product.scale?.toLowerCase() === "meters" ? 0.5 : 1;
  const minVal = step;

  // Stock tiers differ by unit:
  // - Meters (fabric): < 6 = Out of Stock, 6–14 = Low Stock, 15+ = In-Stock
  // - Pieces (sarees etc.): even 1 piece is sellable — 0 = Out, 1–2 = Low, 3+ = In
  const qty = Number(product.quantity) || 0; // API may send quantity as a string
  const isMeters = product.scale?.toLowerCase() === "meters";
  const stockLevel = isMeters
    ? qty < 6 ? "out" : qty < 15 ? "low" : "in"
    : qty < 1 ? "out" : qty <= 2 ? "low" : "in";
  const STOCK_CONFIG = {
    out: { label: "Out of Stock", dot: "bg-red-500", badge: "bg-red-500" },
    low: { label: "Low Stock", dot: "bg-orange-500", badge: "bg-orange-500" },
    in: { label: "In Stock", dot: "bg-green-500", badge: "bg-purple-600" },
  };
  const stockInfo = STOCK_CONFIG[stockLevel];
  const isBuyable = stockLevel !== "out";

  const tabs = ["Description", "Fabric Estimator", "Shipping", "Washcare"];

  const descFields = [
    { label: "Description", value: product.description },
    { label: "Material", value: product.material },
    { label: "Width", value: product.size },
    { label: "Weight", value: product.weight },
    { label: "Quality", value: product.quality },
    { label: "Color", value: product.color },
    { label: "Wash Care", value: product.washcare },
    { label: "Disclaimer", value: product.disclaimer },
    { label: "Note", value: product.note },
    { label: "Mktg. / Mfg. By", value: "Aavaryaa's FabHub" },
  ];

  return (
    <>
      <div
        className="min-h-screen px-6 sm:px-10 lg:px-24 xl:px-36 py-10"
        style={{ background: "linear-gradient(180deg, #F6F1FE 0%, #ffffff 60%)" }}
      >
        {/* Subtle dot grid */}
        <div
          className="fixed inset-0 opacity-[0.025] pointer-events-none z-0"
          style={{
            backgroundImage: "radial-gradient(circle, #8353C6 1px, transparent 1px)",
            backgroundSize: "28px 28px",
          }}
        />

        <div className="relative z-10 max-w-6xl mx-auto">
          <div className="grid grid-cols-1 lg:grid-cols-[3fr_2fr] gap-12 xl:gap-16">

            {/* ── Left: Images (sticky so the photo stays in view while
                 scrolling the longer details column) ── */}
            <div className="flex flex-col gap-4 lg:sticky lg:top-4 lg:self-start">
              {/* Main image */}
              <div
                className="relative overflow-hidden rounded-3xl shadow-xl"
                style={{ cursor: "crosshair" }}
              >
                <img
                  crossOrigin="anonymous"
                  src={selectedImage || product.images[0]}
                  alt="Selected Product"
                  className="w-full h-[480px] sm:h-[620px] lg:h-[540px] object-cover"
                  onMouseMove={handleMouseMove}
                  onMouseLeave={handleMouseLeave}
                  style={zoomStyle}
                  loading="lazy"
                />
                {/* Zoom hint */}
                <div className="absolute bottom-3 right-3 bg-black/40 text-white text-[10px] px-2 py-1 rounded-full backdrop-blur-sm">
                  🔍 Hover to zoom
                </div>
                {/* Bestseller ribbon */}
                {product.bestseller?.toLowerCase() === "yes" && (
                  <div
                    className="absolute top-4 left-0 text-white text-xs font-bold px-4 py-1 rounded-r-full shadow"
                    style={{ background: "linear-gradient(90deg, #8353C6, #9E79D2)" }}
                  >
                    ⭐ BESTSELLER
                  </div>
                )}
              </div>

              {/* Thumbnails */}
              <div className="grid grid-cols-4 gap-2.5">
                {product.images.slice(0, 4).map((item, i) => (
                  <div
                    key={i}
                    onClick={() => setSelectedImage(item)}
                    className={`overflow-hidden rounded-2xl cursor-pointer border-2 transition-all duration-200
                      ${selectedImage === item
                        ? "border-purple-500 shadow-md shadow-purple-200"
                        : "border-gray-100 hover:border-purple-300"}`}
                  >
                    <img
                      crossOrigin="anonymous"
                      src={item}
                      alt={`Thumbnail ${i + 1}`}
                      className="w-full h-24 lg:h-20 object-cover hover:scale-105 transition-transform duration-300"
                    />
                  </div>
                ))}
              </div>

              {/* WhatsApp enquiry */}
              <a
                href={`https://wa.me/919944592904?text=Hi%2C%20I%27m%20interested%20in%20${encodeURIComponent(product.name || "this product")}`}
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center justify-center gap-2 w-full py-2.5 rounded-xl border-2 border-green-500 text-green-700 font-semibold text-sm hover:bg-green-50 transition"
              >
                <FaWhatsapp size={16} />
                Enquire on WhatsApp
              </a>
            </div>

            {/* ── Right: Details ── */}
            <div className="flex flex-col gap-4">

              {/* Design ID + Status */}
              <div className="flex items-center flex-wrap gap-2">
                <span className="text-xs text-gray-500 bg-gray-100 px-3 py-1 rounded-full font-mono">
                  Design ID: {product.unique_id}
                </span>
                <span
                  className={`text-xs text-white px-3 py-1 rounded-full font-semibold ${stockInfo.badge}`}
                >
                  {stockLevel === "out" ? "✗ " : "✓ "}
                  {stockInfo.label}
                </span>
                {product.bestseller?.toLowerCase() === "yes" && (
                  <span className="text-xs text-white bg-yellow-500 px-3 py-1 rounded-full font-semibold">
                    🏆 BESTSELLER
                  </span>
                )}
              </div>

              {/* Product name + wishlist */}
              <div className="flex items-start justify-between gap-3">
                <h1
                  className="text-xl sm:text-2xl font-bold text-gray-900 leading-snug"
                  style={{ fontFamily: "'Times New Roman', serif" }}
                >
                  {product.name}
                </h1>
                <button
                  onClick={() => toggleWishlist({ id: product.id, name: product.name, image: product.images?.[0] || "", new_price: newPrice.toFixed(2) })}
                  className="shrink-0 w-10 h-10 rounded-full flex items-center justify-center shadow-md transition-all duration-200 hover:scale-110 active:scale-95 mt-0.5"
                  style={{
                    background: wishlisted ? "linear-gradient(135deg,#8353C6,#9E79D2)" : "#F6F1FE",
                    border: wishlisted ? "none" : "1.5px solid #EEE5FA",
                  }}
                  title={wishlisted ? "Remove from wishlist" : "Save to wishlist"}
                >
                  {wishlisted
                    ? <FaHeart size={15} color="white" />
                    : <FiHeart size={15} style={{ color: "#8353C6" }} />
                  }
                </button>
              </div>

              {/* Price block */}
              <div className="rounded-2xl p-4 border border-purple-100 bg-purple-50/60">
                <div className="flex items-center flex-wrap gap-3">
                  <span className="text-2xl font-bold text-purple-700">
                    {currency}{newPrice.toFixed(2)}
                  </span>
                  {product.old_price && (
                    <>
                      <span className="text-gray-400 line-through text-sm">
                        {currency}{product.old_price}
                      </span>
                      <span className="bg-green-100 text-green-700 text-xs font-bold px-2.5 py-1 rounded-full">
                        {discountPercentage}% OFF
                      </span>
                    </>
                  )}
                  <span className="text-gray-500 text-sm">
                    /{product.scale === "Meters" ? "meter" : "piece"}
                  </span>
                </div>
                <p className="text-xs text-gray-400 mt-1">
                  M.R.P: <span className="line-through">{currency}{product.old_price}</span>
                  &nbsp;·&nbsp; Inclusive of all taxes
                </p>
              </div>

              {/* Stock info */}
              <p className="text-sm text-gray-600 flex items-center gap-1.5">
                <span className={`w-2 h-2 rounded-full ${stockInfo.dot}`} />
                <span className="font-medium">{qty}</span>
                {product.scale === "Meters" ? " meters" : " pieces"} in stock
                <span className="text-xs text-gray-400">· {stockInfo.label}</span>
              </p>

              {product.scale === "Meters" && (
                <div className="flex flex-wrap items-center gap-x-4 gap-y-1 text-xs text-gray-500 bg-gray-50 border border-gray-100 rounded-full px-4 py-2 w-fit">
                  <span className="flex items-center gap-1.5">
                    <span className="w-2 h-2 rounded-full bg-red-500" /> &lt; 6 — Out of Stock
                  </span>
                  <span className="flex items-center gap-1.5">
                    <span className="w-2 h-2 rounded-full bg-orange-500" /> 6–14 — Low Stock
                  </span>
                  <span className="flex items-center gap-1.5">
                    <span className="w-2 h-2 rounded-full bg-green-500" /> 15+ — In-Stock
                  </span>
                </div>
              )}

              {/* Quantity selector */}
              <div className="flex items-center gap-4 flex-wrap">
                <div className={`flex items-center rounded-xl overflow-hidden border-2 shadow-sm ${
                  isBuyable ? "border-purple-200 bg-white" : "border-gray-200 bg-gray-100"
                }`}>
                  <button
                    className={`px-4 py-2.5 font-bold transition text-lg ${
                      isBuyable ? "text-purple-700 hover:bg-purple-50" : "text-gray-300 cursor-not-allowed"
                    }`}
                    onClick={() => setCount(count > minVal ? count - step : minVal)}
                    disabled={!isBuyable}
                  >
                    −
                  </button>
                  <input
                    type="number"
                    value={count}
                    onChange={handleInputChange}
                    className={`w-16 text-center outline-none text-sm font-semibold ${
                      isBuyable ? "text-gray-800 bg-white" : "text-gray-400 bg-gray-100 cursor-not-allowed"
                    }`}
                    step={step}
                    min={minVal}
                    disabled={!isBuyable}
                  />
                  <button
                    className={`px-4 py-2.5 font-bold transition text-lg ${
                      isBuyable ? "text-purple-700 hover:bg-purple-50" : "text-gray-300 cursor-not-allowed"
                    }`}
                    onClick={() => setCount(Math.min(count + step, qty || count + step))}
                    disabled={!isBuyable}
                  >
                    +
                  </button>
                </div>
                <span className="text-sm text-gray-500">
                  {product.scale === "Meters" ? "Quantity in meters" : "Quantity in pieces"}
                </span>
              </div>

              {/* CTA buttons */}
              <div className="flex flex-col sm:flex-row gap-3">
                {cartItems[product.id] > 0 ? (
                  <button
                    className="flex-1 py-3 rounded-xl border-2 border-red-400 text-red-500 font-bold text-sm hover:bg-red-500 hover:text-white transition-all duration-300"
                    onClick={() => deleteFromCart(product.id)}
                  >
                    ✕ REMOVE FROM CART
                  </button>
                ) : (
                  <button
                    className={`flex-1 py-3 rounded-xl font-bold text-sm transition-all duration-200 ${
                      isBuyable
                        ? "text-white shadow-lg hover:opacity-90 hover:scale-[1.02] active:scale-[0.98]"
                        : "bg-gray-200 text-gray-400 cursor-not-allowed"
                    }`}
                    style={isBuyable ? { background: "linear-gradient(90deg, #8353C6, #9E79D2)" } : {}}
                    disabled={!isBuyable}
                    onClick={isBuyable ? () => addToCart(product.id, count) : null}
                  >
                    🛒 ADD TO CART
                  </button>
                )}
                <button
                  className={`flex-1 py-3 rounded-xl font-bold text-sm transition-all duration-200 ${
                    isBuyable
                      ? "text-white shadow-lg hover:opacity-90 hover:scale-[1.02] active:scale-[0.98]"
                      : "bg-gray-200 text-gray-400 cursor-not-allowed"
                  }`}
                  style={isBuyable ? { background: "linear-gradient(90deg, #6939AC, #8353C6)" } : {}}
                  onClick={isBuyable ? handlePopupNow : null}
                  disabled={!isBuyable}
                >
                  {isBuyable ? "⚡ BUY NOW" : "OUT OF STOCK"}
                </button>
              </div>

              {/* Request block — shown when out of stock, or when the buyer
                  wants more than what's currently available */}
              {(!isBuyable || count >= qty) && (
                <div className="rounded-2xl border border-purple-100 bg-purple-50/50 p-4">
                  {!showRequestForm ? (
                    <button
                      onClick={() => {
                        setShowRequestForm(true);
                        setRequestQty(!isBuyable ? (isMeters ? 6 : 1) : qty + step);
                      }}
                      className="flex items-center justify-center gap-2 w-full py-2.5 rounded-xl border-2 border-purple-400 text-purple-700 font-semibold text-sm hover:bg-purple-100 transition"
                    >
                      {!isBuyable
                        ? "📩 Request This Item"
                        : `Need more than ${qty} ${isMeters ? "meters" : qty === 1 ? "piece" : "pieces"}? 📩 Request It`}
                    </button>
                  ) : (
                    <div className="flex flex-col gap-3">
                      <p className="text-sm font-semibold text-purple-800">
                        Tell us how much you need — we'll check with the shop and get back to you.
                      </p>

                      <div className="flex items-center gap-3">
                        <label className="text-xs font-medium text-gray-600 whitespace-nowrap">
                          Quantity needed ({product.scale === "Meters" ? "meters" : "pieces"})
                        </label>
                        <input
                          type="number"
                          min={step}
                          step={step}
                          value={requestQty}
                          onChange={(e) => setRequestQty(e.target.value)}
                          className="w-24 border border-purple-200 rounded-lg px-3 py-2 text-sm text-center focus:ring-2 focus:ring-purple-400 outline-none bg-white"
                        />
                      </div>

                      <textarea
                        value={requestNote}
                        onChange={(e) => setRequestNote(e.target.value)}
                        placeholder="Any notes for the shop (e.g. preferred delivery date, color match, urgency)"
                        rows={3}
                        className="w-full border border-purple-200 rounded-lg px-3 py-2 text-sm focus:ring-2 focus:ring-purple-400 outline-none bg-white resize-none"
                      />

                      <div className="flex gap-3">
                        <a
                          href={`https://wa.me/919944592904?text=${encodeURIComponent(
                            `Hi, I'd like to request restock for "${product.name}" (Design ID: ${product.unique_id}).\n` +
                            `Quantity needed: ${requestQty} ${product.scale === "Meters" ? "meters" : "pieces"}\n` +
                            (requestNote ? `Note: ${requestNote}` : "")
                          )}`}
                          target="_blank"
                          rel="noopener noreferrer"
                          onClick={() => toast.success("Opening WhatsApp to send your request…")}
                          className="flex-1 flex items-center justify-center gap-2 py-2.5 rounded-xl text-white font-bold text-sm shadow-lg hover:opacity-90 transition"
                          style={{ background: "linear-gradient(90deg, #25D366, #128C7E)" }}
                        >
                          <FaWhatsapp size={16} /> Send Request
                        </a>
                        <button
                          onClick={() => setShowRequestForm(false)}
                          className="px-4 py-2.5 rounded-xl border border-gray-300 text-gray-500 text-sm font-medium hover:bg-gray-50 transition"
                        >
                          Cancel
                        </button>
                      </div>
                    </div>
                  )}
                </div>
              )}

              {/* Trust badges */}
              <div className="rounded-2xl border border-purple-100 bg-white p-4">
                <p className="text-xs font-bold uppercase tracking-widest text-purple-500 mb-3">
                  When you choose Aavryaa
                </p>
                <div className="grid grid-cols-3 gap-3">
                  {[
                    { icon: quality_icon, label: "Exceptional Quality" },
                    { icon: money_icon, label: "Value For Money" },
                    { icon: trust_icon, label: "Trust Of Brand" },
                  ].map(({ icon, label }) => (
                    <div key={label} className="flex flex-col items-center gap-1.5 bg-purple-50 rounded-xl p-2.5 text-center">
                      <img crossOrigin="anonymous" src={icon} className="w-7 h-7" alt={label} />
                      <p className="text-[11px] font-semibold text-gray-700 leading-tight">{label}</p>
                    </div>
                  ))}
                </div>
              </div>

              {/* Delivery info strip */}
              <div className="flex flex-wrap gap-3 text-xs text-gray-600">
                {[
                  { icon: <MdLocalShipping className="text-purple-500" />, text: "Free shipping on orders ₹999+" },
                  { icon: <MdVerified className="text-green-500" />, text: "100% Genuine fabric" },
                  { icon: <FaShieldAlt className="text-purple-400" />, text: "7-day returns" },
                ].map(({ icon, text }) => (
                  <div key={text} className="flex items-center gap-1.5 bg-gray-50 border border-gray-100 rounded-full px-3 py-1.5">
                    {icon}
                    <span>{text}</span>
                  </div>
                ))}
              </div>

              {/* Tabs */}
              <div className="mt-2">
                <div className="flex gap-1 border-b border-purple-100 overflow-x-auto">
                  {tabs.map((tab) => (
                    <button
                      key={tab}
                      onClick={() => setActiveTab(tab)}
                      className={`whitespace-nowrap pb-3 px-4 text-sm font-semibold tracking-wide transition-all ${
                        activeTab === tab
                          ? "border-b-2 border-purple-600 text-purple-700"
                          : "text-gray-400 hover:text-purple-400"
                      }`}
                    >
                      {tab}
                    </button>
                  ))}
                </div>

                <div className="mt-4">
                  {activeTab === "Description" && (
                    <div className="rounded-2xl overflow-hidden border border-purple-100">
                      {descFields.filter(f => f.value).map(({ label, value }, i) => (
                        <div
                          key={label}
                          className="flex gap-4 px-4 py-3.5 border-b border-gray-50 last:border-b-0"
                          style={{ background: i % 2 === 0 ? "#F6F1FE" : "#ffffff" }}
                        >
                          <span className="text-sm font-bold text-purple-600 w-36 flex-shrink-0 leading-relaxed">
                            {label}
                          </span>
                          <span className="text-sm text-gray-700 leading-relaxed">{value}</span>
                        </div>
                      ))}
                    </div>
                  )}

                  {activeTab === "Fabric Estimator" && (
                    <div className="space-y-3">
                      <p className="text-sm text-gray-600">Confused about how much fabric you need? Use our estimator!</p>
                      <button
                        onClick={() => setOpenModal(true)}
                        className="py-2.5 px-6 rounded-xl text-white text-sm font-semibold shadow hover:opacity-90 transition"
                        style={{ background: "linear-gradient(90deg, #8353C6, #9E79D2)" }}
                      >
                        View Estimator
                      </button>
                      <EstimatorModal
                        isOpen={openModal}
                        onClose={() => setOpenModal(false)}
                        image1={EstimatorImage1}
                        image2={EstimatorImage2}
                      />
                    </div>
                  )}

                  {activeTab === "Shipping" && (
                    <div className="space-y-3">
                      <div className="flex items-start gap-3 p-4 bg-purple-50 rounded-2xl border border-purple-100">
                        <MdLocalShipping className="text-purple-500 text-2xl mt-0.5 flex-shrink-0" />
                        <div>
                          <p className="font-bold text-gray-800 text-sm mb-1">Pan India Delivery</p>
                          <p className="text-sm text-gray-600">We ship across India with care and speed. Orders above ₹999 get free shipping.</p>
                        </div>
                      </div>
                    </div>
                  )}

                  {activeTab === "Washcare" && (
                    <div className="p-4 bg-blue-50 rounded-2xl border border-blue-100">
                      <p className="font-bold text-sm text-blue-700 mb-2">Wash Care Instructions</p>
                      <p className="text-sm text-gray-700 leading-relaxed">{product.washcare}</p>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>

          {/* About section below */}
          <div className="mt-12">
            <About />
          </div>
        </div>

        <OrderPopup
          showPopup={showPopup}
          closePopup={closePopup}
          product={product}
          selectedSize={selectedSize}
          count={count}
          currency="₹"
          price={newPrice}
        />
      </div>
    </>
  );
};

export default Products;
